import React, { useState,useEffect } from "react";
import "../style/create.css";
import { postWithoutTokenAPI } from "../util/Api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
const ForgotPassword = () => {
    const navigate = useNavigate();
    const [phonenumber, setPhonenumber] = useState("");
    const [error, setError] = useState("");
    const login = useSelector((state) => state.auth?.auth?.access_token);

    const validatePhoneNumber = (number) => /^[0-9]{10,15}$/.test(number);

    const handleSubmit = async () => {
        setError("");
        const cleanNumber = phonenumber.trim();

        if (!cleanNumber) {
            setError("Phone number is required");
            return;
        }

        if (!validatePhoneNumber(cleanNumber)) {
            setError("Please enter a valid phone number");
            return;
        }

        try {
            const response = await postWithoutTokenAPI("/auth/otpsendforgot", {
                phone_number: cleanNumber,
            });

            if (response.statusCode === 200) {
                toast.success("OTP sent successfully!");
                setPhonenumber(""); // clear the input

                setTimeout(() => {
                    navigate("/forgot-otp", {
                        state: {
                            phone_number: cleanNumber,
                            // fromForgotPassword: true,
                        },
                    });
                }, 2000);
            } else {
                setError(response.message || "Request failed.");
            }
        } catch (err) {
            setError("An error occurred. Please try again.");
            console.error(err);
        }
    };

    useEffect(() => {
        if (login) {
            navigate('/user'); // or any page you want
        }
    }, [login, navigate]);

    return (
        <>

          
            <div className="auth-box">
                <ToastContainer autoClose={3000} />
                <h2 className="auth-title">Forgot Password</h2>
                <div className="auth-field">
                    <input
                        className="auth-input"
                        type="text"
                        placeholder="Enter your phone number"
                        value={phonenumber}
                        onChange={(e) => setPhonenumber(e.target.value)}
                    />
                </div>
                {error && <div className="auth-error">{error}</div>}
                <button className="auth-button" onClick={handleSubmit}>
                    Send OTP
                </button>
            </div>

</>

    );
};

export default ForgotPassword;
